import React, { useEffect } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

type Props = {
	value: string;
	style?: React.CSSProperties;
	className?: string;
	onChange: (value: string) => void;
};

// Register Barlow font with Quill
const Font = Quill.import("formats/font");
Font.whitelist = ["barlow", "arial", "monospace"];
Quill.register(Font, true);

const fontStyle = `
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="barlow"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="barlow"]::before {
  content: "Barlow";
  font-family: 'Barlow', sans-serif;
}
.ql-font-barlow {
  font-family: 'Barlow', sans-serif;
}
`;

export default function Editor(props: Props) {
	const { value, onChange, style, className } = props;

	 useEffect(() => {
        // Inject font style for Barlow
        if (!document.getElementById("quill-barlow-font-style")) {
            const styleTag = document.createElement("style");
            styleTag.id = "quill-barlow-font-style";
            styleTag.innerHTML = fontStyle;
            document.head.appendChild(styleTag);
        }
    }, []);

	return (
		<ReactQuill
			id="react-quill-editor"
			theme="snow"
			className={className}
			style={style}
			value={value}
			onChange={onChange}
			formats={[
				"header",
				"font",
				"size",
				"bold",
				"italic",
				"underline",
				"blockquote",
				"list",
				"bullet",
				"indent",
				"link",
				"image",
				"video",
				"color",
				"background",
				"align",
				"script",
			]}
			modules={{
				toolbar: [
					[{ font: Font.whitelist }],
					[{ header: "1" }, { header: "2" }, { font: [] }],
					[{ size: [] }],
					["bold", "italic", "underline", "blockquote", "code-block"],
					[
                        { script: "sub" },
                        { script: "super" }
                    ],
					[{ align: [] }, { align: "center" }, { align: "right" }, { align: "justify" }],
					[{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
					["link", "image", "video"],
					[{ color: [] }, { background: [] }],
					["clean"]
				],
				clipboard: {
					matchVisual: false
				}
			}}
		/>
	);
}
